/**
 * FreeFic 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * FreeFic 品牌特定主题配置
 */
export const theme = {
  // 头像边框色
  avatarBorder: '#FFF7EF',
  // 按钮背景色
  btnPrimaryBg: '#FFF7EF',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(315deg, #E65F3D 0%, #FFAD75 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/freefic/member_subscribe_bg.webp)',
} as const

/**
 * FreeFic 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/freefic/member-bg.svg',
  // 用户背景图
  userBg: '/images/freefic/user-bg.svg',
  // 用户默认头像
  userDefaultAvatar: '/images/freefic/user-default.png',
  // VIP 图标
  memberVip: '/images/freefic/member/vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/freefic/vip-icon.png',
  vipIcon: '/images/freefic/vip-icon.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
  menuIcons: {
    transaction: '/images/freefic/member/icon-transaction.png',
    unlocked: '/images/freefic/member/icon-unlock.png',
    contactUs: '/images/freefic/member/icon-contact.png',
    setting: '/images/freefic/member/icon-setting.png',
  },
}
